module.exports = "<div>\r\n  <div class=\"header\">\r\n    <h3> <span s-if=\"!!subTitle\" class=\"left\" on-click=\"back\"><i></i>{{subTitle}}</span> <span>{{title}}</span></h3>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/homeHeader.html
// module id = 357
// module chunks = 1